<template>
  <svg width="25" height="24" viewBox="0 0 25 24">
    <path
      d="M10.14 12.466a3.75 3.75 0 0 0 4.789-.034l-.063.048.042.049 6.936 6.971H3.197l6.89-6.973zM2 5.513l7 5.979-6.997 7.083A1.014 1.014 0 0 1 2 18.5V5.513zm21 .127V18.5l-.002.033-6.982-7.017L23 5.64zM22 4.5l.024.001-8.061 6.783a2.25 2.25 0 0 1-2.767.102l-.143-.112L3.121 4.5H22z"
      fill="#1D1D20"
      fill-rule="evenodd"
    />
  </svg>
</template>
